import React from 'react';
import PropTypes from 'prop-types';
import { Box, Heading, Flex } from 'roo-ui/components';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { mediaQuery } from 'lib/styledSystem';
import RoomTypeDisplayMeta from './components/RoomTypeDisplayMeta';
import { UnavailableMessage } from './components/primitives';

const OccupantsWrapper = styled(Flex)`
  flex-grow: 1;
`;

const Wrapper = styled(Flex)`
  padding: ${themeGet('space.4')};
  background-color: ${themeGet('colors.white')};
  box-shadow: ${themeGet('shadows.hard')};

  ${mediaQuery.minWidth.sm} {
    border-radius: ${themeGet('radii.default')};
    padding: ${themeGet('space.6')} ${themeGet('space.4')};
  }
`;

export const UnavailableRoomTypeWrapper = styled(Box)`
  padding-top: ${themeGet('space.2')};
  margin-bottom: ${themeGet('space.2')};

  &:first-of-type {
    padding-top: 0;
    margin-top: 0;
  }
`;

const UnavailableRoomType = ({ roomType, hasQuery }) => {
  const { name, maxOccupantCount } = roomType;

  return (
    <UnavailableRoomTypeWrapper data-testid="unavailable-room-type">
      <Wrapper flex="1 1 auto" flexDirection={['column', 'row']}>
        <Box fontSize="md" fontWeight="normal" mb={0} as={Heading.h3} width={['100%', '45%']}>
          {name}
        </Box>
        <OccupantsWrapper>
          <RoomTypeDisplayMeta maxOccupantCount={maxOccupantCount} />
        </OccupantsWrapper>
        {!hasQuery && <UnavailableMessage>Select stay dates to show prices</UnavailableMessage>}
        {hasQuery && <UnavailableMessage>Not available for your dates</UnavailableMessage>}
      </Wrapper>
    </UnavailableRoomTypeWrapper>
  );
};

UnavailableRoomType.propTypes = {
  roomType: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    roomTypeFacilities: PropTypes.array.isRequired,
    offers: PropTypes.array,
    maxOccupantCount: PropTypes.number,
    images: PropTypes.array,
    mainImage: PropTypes.shape({
      urlMedium: PropTypes.string,
      caption: PropTypes.string,
    }),
  }).isRequired,
  hasQuery: PropTypes.bool,
};

UnavailableRoomType.defaultProps = {
  hasQuery: false,
};

export default UnavailableRoomType;
